import {pathIs} from "../../utilities";

export const groupReport = () => {
    const body = $('body');

    if(pathIs('/app/inventories/group-report')) {
        const statuses = [];
        const parsedStatuses = window.STATUSES ? JSON.parse(window.STATUSES) : [];

        for(const value in parsedStatuses) {
            statuses.push({
                value: 'status:'+value,
                text: parsedStatuses[value]
            });
        }

        const types = window.INVENTORY_TYPES ? JSON.parse(window.INVENTORY_TYPES).map(type => ({
            value: 'type:'+type.id,
            text: type.name
        })) : [];

        const templates = window.TEMPLATES ? JSON.parse(window.TEMPLATES).map(template => ({
            value: 'template:'+template.id,
            text: template.name
        })) : [];

        $('[data-app-filter]').on('click', function() {
            const form = $(this).closest('form')

            const from = form.find('[name="from"]').val()
            const to = form.find('[name="to"]').val()

            window.location = `/app/inventories/group-report?from=${from}&to=${to}`
        })

        const isRsfOrSupervisionWorker = window.IS_RSF_WORKER || window.IS_SUPERVISION_WORKER;

        const STATUSES_INDEX = isRsfOrSupervisionWorker ? 3 : 2;
        const TYPES_INDEX = isRsfOrSupervisionWorker ? 4 : 3;
        const TEMPLATES_INDEX = isRsfOrSupervisionWorker ? 5 : 4;

        let columns = [
            {
                index: STATUSES_INDEX,
                values: statuses,
                regex: '{value}'
            },
            {
                index: TYPES_INDEX,
                values: types,
                regex: '{value}'
            },
            {
                index: TEMPLATES_INDEX,
                values: templates,
                regex: '{value}'
            },
        ]

        if(isRsfOrSupervisionWorker) {
            columns = [
                ...columns,
                {
                    index: 2,
                }
            ]
        }

        const table = $('#inventories_table').DataTable({
            filters: {
                columns
            }
        });

        let currentTemplate = null;
        let currentType = null;
        let currentStatus = null;

        const query = 'input[name^="inventory_id["][name$="]"]'

        body.on('change', query, function() {
            currentTemplate = $(this).data('app-template');
            currentType = $(this).data('app-type');
            currentStatus = $(this).data('app-status');

            const checked = table.$(query+':checked');

            if(checked.length) {
                table
                    .$(`${query}[data-app-template="${currentTemplate}"][data-app-type="${currentType}"]`)
                    .attr('disabled', false);

                table
                    .$(`${query}:not([data-app-template="${currentTemplate}"][data-app-type="${currentType}"])`)
                    .attr('disabled', true);
            } else {
                table
                    .$(`${query}`)
                    .attr('disabled', false);
            }

            if(checked.length) {
                $(`[data-value="template:${currentTemplate}"]`).click();
                $(`[data-value="type:${currentType}"]`).click();
            } else {
                $('[data-app-filter_column="3"]').find('[data-value=""]').click();
                $('[data-app-filter_column="4"]').find('[data-value=""]').click();
            }
        });

        $(`${query}:checked`).change();
    }
}